export const insertTextAtSelection = (
  value: string,
  insertion: string,
  selectionStart: number,
  selectionEnd: number
): { nextValue: string; nextCursor: number } => {
  const start = Math.max(0, Math.min(selectionStart, value.length));
  const end = Math.max(start, Math.min(selectionEnd, value.length));
  const nextValue = `${value.slice(0, start)}${insertion}${value.slice(end)}`;
  return { nextValue, nextCursor: start + insertion.length };
};

export const restoreTextareaSelection = (
  element: HTMLTextAreaElement | null,
  cursor: number
): void => {
  if (!element) {
    return;
  }
  element.focus();
  element.setSelectionRange(cursor, cursor);
};
